import styled from "styled-components";

export const AuthWrapper = styled.div`
background: #F2F2F3;
position: relative;
padding: 3em 0;
width: 100%;
height: auto;
`